import React, { FC, useEffect } from "react";
import { Form, Input, Select, Button, Row, Col, Spin } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { updateField } from "../../../../models/preAuthClaimSlice";
import { errorMessage } from "../../../../utils/notificationUtils";
import { Collapse } from "antd";

interface EchsExtraFormProps {
  form: any;
  isEditable: boolean;
  caseClaimSubmissionId: number | null;
  portalSubmission: boolean;
  handleDeleteProcedure?: (procedure: any) => boolean;
  totalClaimedAmountRoomCharges?: number;
  totalClaimedAmountConsultationCharges?: number;
  totalClaimedAmountImplantCharges?: number;
  totalClaimedAmountUnlistedProcedure?: number;
  totalEchsRateRoomCharges?: number;
  totalEchsRateConsultationCharges?: number;
  totalEchsImplantCharges?: number;
  totalClaimedAmount?: number;
  totalEchsRate?: number;
  roomChargesOptions: any;
  consultationChargesOptions: any;
  implantList: any;
  onAmountChange?: any;
  isFetchingRoomCharges: boolean;
  isFetchingConsultationCharges: boolean;
  isFetchingImplantList: boolean;
}

const { Panel } = Collapse;

const EchsExtraForm: FC<EchsExtraFormProps> = ({
  form,
  isEditable,
  caseClaimSubmissionId,
  portalSubmission,
  handleDeleteProcedure,
  totalClaimedAmountRoomCharges,
  totalClaimedAmountConsultationCharges,
  totalClaimedAmountImplantCharges,
  totalClaimedAmountUnlistedProcedure,
  totalEchsRateRoomCharges,
  totalEchsRateConsultationCharges,
  totalEchsImplantCharges,
  roomChargesOptions,
  consultationChargesOptions,
  implantList,
  onAmountChange,
  isFetchingRoomCharges,
  isFetchingConsultationCharges,
  isFetchingImplantList,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const roomCharges = form.getFieldValue("roomChargesList") || [];
    const consultation = form.getFieldValue("consultationList") || [];
    const implant = form.getFieldValue("implantList") || [];
    const unlisted = form.getFieldValue("unlistedProcedureList") || [];

    const calculateHospitalAmount = (list: any[], fieldName: string) => {
      const updatedList = list.map((item) => {
        const daysUnits = parseFloat(item?.daysUnits || 0);
        const hospitalRate = parseFloat(item?.hospitalRate || 0);
        const hospitalAmount =
          daysUnits && hospitalRate ? (daysUnits * hospitalRate).toFixed(2) : 0;
        return { ...item, hospitalAmount };
      });

      form.setFieldsValue({ [fieldName]: updatedList });
    };

    calculateHospitalAmount(roomCharges, "roomChargesList");
    calculateHospitalAmount(consultation, "consultationList");
    calculateHospitalAmount(implant, "implantList");
    calculateHospitalAmount(unlisted, "unlistedProcedureList");
  }, [form]);

  return (
    <>
      <Collapse
        defaultActiveKey={["1"]}
        bordered={false}
        style={{
          border: "1px solid lightgray",
          borderRadius: "20px",
          marginBottom: "1rem",
          background: "#F2F6F9",
          padding: "2px 10px",
        }}
      >
        <Panel
          header={<h4 style={{ margin: 0 }}>Room Charges</h4>}
          key="1"
          style={{ borderRadius: "20px" }}
        >
          {isFetchingRoomCharges ? (
            <div
              style={{
                margin: "auto",
                width: "100%,",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Spin />
            </div>
          ) : (
            <Form.List name="roomChargesList">
              {(fields, { add, remove }) => (
                <>
                  <div
                    style={{
                      maxHeight: "50vh",
                      overflowY: "auto",
                      overflowX: "hidden",
                      padding: "20px",
                      marginBottom: "1rem",
                    }}
                  >
                    {fields.map((field, index) => {
                      const itemActive = form.getFieldValue([
                        "roomChargesList",
                        index,
                        "active",
                      ]);
                      if (itemActive === false) return null;

                      return (
                        <Row
                          key={field.key}
                          gutter={[16, 0]}
                          align="top"
                          style={{
                            border: "1px solid black",
                            padding: "10px 20px",
                            borderRadius: "16px",
                            marginBottom: "0.8rem",
                          }}
                        >
                          <Col span={8}>
                            <Form.Item
                              {...field}
                              className="small-label"
                              label="Room Charges Code"
                              name={[field.name, "cghsCode"]}
                              // rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                            >
                              <Select
                                placeholder="Select Room Charges Code"
                                disabled={
                                  !isEditable && !!caseClaimSubmissionId
                                }
                                allowClear
                                style={{ width: "100%" }}
                                options={roomChargesOptions}
                                onChange={(value, option: any) => {
                                  form.setFieldsValue({
                                    roomChargesList: {
                                      [index]: {
                                        cghsRate: option.cghsRate,
                                        daysUnits: "1",
                                        hospitalRate: null,
                                      },
                                    },
                                  });
                                }}
                                //   options={[
                                //     { label: "Room Code 1", value: "room1" },
                                //     { label: "Room Code 2", value: "room2" },
                                //     { label: "Room Code 3", value: "room3" },
                                //   ]}
                              />
                              {/* <Input
                          placeholder="Enter Room Charges Code"
                          disabled={!isEditable && !!caseClaimSubmissionId}
                        /> */}
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              {...field}
                              className="small-label"
                              label="QUANTITY/NO OF DAYS"
                              name={[field.name, "daysUnits"]}
                              rules={[
                                { required: true, message: "Required" },
                                {
                                  pattern: /^\d+$/,
                                  message: "Only numeric values are allowed!",
                                },
                              ]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                            >
                              <Input
                                placeholder="Enter QUANTITY/NO OF DAYS"
                                onChange={(e) => {
                                  onAmountChange?.();
                                  const enteredExpenseUnit =
                                    e.target.value.trim();
                                  const hospitalRate = form.getFieldValue([
                                    "roomChargesList",
                                    index,
                                    "hospitalRate",
                                  ]);

                                  if (hospitalRate && enteredExpenseUnit) {
                                    const hospitalAmount =
                                      parseFloat(hospitalRate) *
                                      parseFloat(enteredExpenseUnit);
                                    form.setFieldsValue({
                                      roomChargesList: {
                                        [index]: {
                                          hospitalAmount:
                                            hospitalAmount?.toString(),
                                        },
                                      },
                                    });
                                  }
                                }}
                                disabled={
                                  !isEditable && !!caseClaimSubmissionId
                                }
                              />
                            </Form.Item>
                          </Col>

                          <Col span={7}>
                            <Form.Item
                              {...field}
                              className="small-label"
                              label="ECHS RATE"
                              name={[field.name, "cghsRate"]}
                              rules={[{ required: false, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                            >
                              <Input
                                placeholder="Enter ECHS RATE"
                                disabled={true}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={1}>
                            {fields.length > 0 &&
                              !(!isEditable && !!caseClaimSubmissionId) &&
                              !portalSubmission && (
                                <Button
                                  type="text"
                                  style={{ color: "red", padding: "0" }}
                                  icon={<MinusCircleOutlined />}
                                  // onClick={() => remove(field.name)}
                                  onClick={() => {
                                    const updatedList =
                                      form.getFieldValue("roomChargesList");
                                    updatedList[index].active = false;
                                    form.setFieldsValue({
                                      roomChargesList: updatedList,
                                    });
                                  }}
                                />
                              )}
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              {...field}
                              className="small-label"
                              label="Hospital Rate"
                              name={[field.name, "hospitalRate"]}
                              rules={[
                                { required: true, message: "Required" },
                                // {
                                //   pattern: /^\d+$/,
                                //   message: "Numeric values are allow!",
                                // },
                                {
                                  pattern: /^(\d+(\.\d{1,2})?|\.\d{1,2})$/,
                                  message:
                                    "Only numeric values with up to 2 decimal places are allowed!",
                                },
                                {
                                  validator: async (_, value) => {
                                    const cghsRate = form.getFieldValue([
                                      "roomChargesList",
                                      index,
                                      "cghsRate",
                                    ]);
                                    if (
                                      value &&
                                      parseFloat(value) > parseFloat(cghsRate)
                                    ) {
                                      return Promise.reject(
                                        new Error(
                                          `Hospital Rate must be lesser than or equal to ${cghsRate}`,
                                        ),
                                      );
                                    }
                                  },
                                },
                              ]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                            >
                              <Input
                                placeholder="Enter Hospital Rate"
                                onChange={(e) => {
                                  onAmountChange?.();
                                  const enteredHospitalRate =
                                    e.target.value.trim();
                                  const cghsRate = form.getFieldValue([
                                    "roomChargesList",
                                    index,
                                    "cghsRate",
                                  ]);
                                  const daysUnits = form.getFieldValue([
                                    "roomChargesList",
                                    index,
                                    "daysUnits",
                                  ]);

                                  if (
                                    parseFloat(enteredHospitalRate) >
                                    parseFloat(cghsRate)
                                  ) {
                                    errorMessage(
                                      `Hospital Rate must be lesser than or equal to ${cghsRate}`,
                                    );
                                  } else if (daysUnits && enteredHospitalRate) {
                                    const hospitalAmount =
                                      parseFloat(daysUnits) *
                                      parseFloat(enteredHospitalRate);
                                    form.setFieldsValue({
                                      roomChargesList: {
                                        [index]: {
                                          hospitalAmount:
                                            hospitalAmount?.toString(),
                                        },
                                      },
                                    });
                                  }
                                }}
                                disabled={
                                  !isEditable && !!caseClaimSubmissionId
                                }
                              />
                            </Form.Item>
                          </Col>

                          <Col span={7}>
                            <Form.Item
                              {...field}
                              className="small-label"
                              label="Remarks"
                              name={[field.name, "remarks"]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                            >
                              <Input
                                placeholder="Enter Remarks"
                                disabled={
                                  !isEditable && !!caseClaimSubmissionId
                                }
                              />
                            </Form.Item>
                          </Col>

                          <div style={{ width: "100%" }}>
                            <h4
                              style={{ display: "flex", justifyContent: "end" }}
                            >
                              Hospital Amount: ₹{" "}
                              {form.getFieldValue([
                                "roomChargesList",
                                index,
                                "hospitalAmount",
                              ]) ?? 0}
                              /-
                            </h4>
                          </div>
                        </Row>
                      );
                    })}
                  </div>

                  {!portalSubmission && (
                    <Button
                      type="dashed"
                      // onClick={() => add({ type: "roomCharges" })}
                      onClick={() => add({ active: true, type: "roomCharges" })}
                      style={{
                        color: "white",
                        background: "rgb(0, 76, 143)",
                        border: "1px solid #C4C4C4",
                        boxShadow: "0px 2px 8px 0px #00000040",
                      }}
                      disabled={!isEditable && !!caseClaimSubmissionId}
                    >
                      Add Room Charges
                    </Button>
                  )}

                  <div
                    style={{
                      width: "100%",
                      marginBottom: "0.8rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <h4
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        marginRight: "2rem",
                      }}
                    >
                      Total Room Echs Rate: ₹ {totalEchsRateRoomCharges || 0}/-
                    </h4>

                    <h4 style={{ display: "flex", justifyContent: "end" }}>
                      Total Room Amount: ₹ {totalClaimedAmountRoomCharges || 0}
                      /-
                    </h4>
                  </div>
                </>
              )}
            </Form.List>
          )}
        </Panel>
      </Collapse>
      {/* <Collapse
        defaultActiveKey={["1"]}
        bordered={false}
        style={{
          border: "1px solid lightgray",
          borderRadius: "20px",
          marginBottom: "1rem",
          background: "#F2F6F9",
          padding: "2px 10px",
        }}
      >
        <Panel
          header={<h4 style={{ margin: 0 }}>Consultation</h4>}
          key="1"
          style={{ borderRadius: "20px" }}
        >
          <Form.List name="consultationList">
            {(fields, { add, remove }) => (
              <>
                {fields.map((field, index) => {
                  const itemActive = form.getFieldValue([
                    "consultationList",
                    index,
                    "active",
                  ]);
                  if (itemActive === false) return null;

                  return (
                    <Row
                      key={field.key}
                      gutter={[16, 0]}
                      align="top"
                      style={{
                        border: "1px solid black",
                        padding: "10px 20px",
                        borderRadius: "16px",
                        marginBottom: "0.8rem",
                      }}
                    >
                      <Col span={8}>
                        <Form.Item
                          {...field}
                          className="small-label"
                          label="Consultation Code"
                          name={[field.name, "cghsCode"]}
                          // rules={[{ required: true, message: "Required" }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                        >
                          <Select
                            placeholder="Select Consultation"
                            disabled={!isEditable && !!caseClaimSubmissionId}
                            allowClear
                            style={{ width: "100%" }}
                            options={consultationChargesOptions}
                            onChange={(value, option: any) => {
                              form.setFieldsValue({
                                consultationList: {
                                  [index]: {
                                    cghsRate: option.cghsRate,
                                    daysUnits: "1",
                                    hospitalRate: null,
                                  },
                                },
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={8}>
                        <Form.Item
                          {...field}
                          className="small-label"
                          label="QUANTITY/NO OF DAYS"
                          name={[field.name, "daysUnits"]}
                          rules={[
                            { required: true, message: "Required" },
                            {
                              pattern: /^\d+$/,
                              message: "Only numeric values are allowed!",
                            },
                          ]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                        >
                          <Input
                            placeholder="Enter QUANTITY/NO OF DAYS"
                            onChange={(e) => {
                              const enteredExpenseUnit = e.target.value.trim();
                              const hospitalRate = form.getFieldValue([
                                "consultationList",
                                index,
                                "hospitalRate",
                              ]);

                              if (hospitalRate && enteredExpenseUnit) {
                                const hospitalAmount =
                                  parseFloat(hospitalRate) *
                                  parseFloat(enteredExpenseUnit);
                                form.setFieldsValue({
                                  consultationList: {
                                    [index]: {
                                      hospitalAmount:
                                        hospitalAmount?.toString(),
                                    },
                                  },
                                });
                              }
                            }}
                            disabled={!isEditable && !!caseClaimSubmissionId}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={7}>
                        <Form.Item
                          {...field}
                          className="small-label"
                          label="ECHS RATE"
                          name={[field.name, "cghsRate"]}
                          rules={[{ required: false, message: "Required" }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                        >
                          <Input
                            placeholder="Enter ECHS RATE"
                            disabled={true}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={1}>
                        {fields.length > 0 &&
                          !(!isEditable && !!caseClaimSubmissionId) &&
                          !portalSubmission && (
                            <Button
                              type="text"
                              style={{ color: "red", padding: "0" }}
                              icon={<MinusCircleOutlined />}
                              // onClick={() => remove(field.name)}
                              onClick={() => {
                                const updatedList =
                                  form.getFieldValue("consultationList");
                                updatedList[index].active = false;
                                form.setFieldsValue({
                                  consultationList: updatedList,
                                });
                              }}
                            />
                          )}
                      </Col>

                      <Col span={8}>
                        <Form.Item
                          {...field}
                          className="small-label"
                          label="Hospital Rate"
                          name={[field.name, "hospitalRate"]}
                          rules={[
                            { required: true, message: "Required" },
                            // {
                            //   pattern: /^\d+$/,
                            //   message: "Numeric values are allow!",
                            // },
                            {
                              pattern: /^(\d+(\.\d{1,2})?|\.\d{1,2})$/,
                              message:
                                "Only numeric values with up to 2 decimal places are allowed!",
                            },
                            {
                              validator: async (_, value) => {
                                const cghsRate = form.getFieldValue([
                                  "consultationList",
                                  index,
                                  "cghsRate",
                                ]);
                                if (
                                  value &&
                                  parseFloat(value) > parseFloat(cghsRate)
                                ) {
                                  return Promise.reject(
                                    new Error(
                                      `Hospital Rate must be lesser than or equal to ${cghsRate}`
                                    )
                                  );
                                }
                              },
                            },
                          ]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                        >
                          <Input
                            placeholder="Enter Hospital Rate"
                            onChange={(e) => {
                              const enteredHospitalRate = e.target.value.trim();
                              const cghsRate = form.getFieldValue([
                                "consultationList",
                                index,
                                "cghsRate",
                              ]);
                              const daysUnits = form.getFieldValue([
                                "consultationList",
                                index,
                                "daysUnits",
                              ]);

                              if (
                                parseFloat(enteredHospitalRate) >
                                parseFloat(cghsRate)
                              ) {
                                errorMessage(
                                  `Hospital Rate must be lesser than or equal to ${cghsRate}`
                                );
                              } else if (daysUnits && enteredHospitalRate) {
                                const hospitalAmount =
                                  parseFloat(daysUnits) *
                                  parseFloat(enteredHospitalRate);
                                form.setFieldsValue({
                                  consultationList: {
                                    [index]: {
                                      hospitalAmount:
                                        hospitalAmount?.toString(),
                                    },
                                  },
                                });
                              }
                            }}
                            disabled={!isEditable && !!caseClaimSubmissionId}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={7}>
                        <Form.Item
                          {...field}
                          className="small-label"
                          label="Remarks"
                          name={[field.name, "remarks"]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                        >
                          <Input
                            placeholder="Enter Remarks"
                            disabled={!isEditable && !!caseClaimSubmissionId}
                          />
                        </Form.Item>
                      </Col>

                      <div style={{ width: "100%" }}>
                        <h4 style={{ display: "flex", justifyContent: "end" }}>
                          Hospital Amount: ₹{" "}
                          {form.getFieldValue([
                            "consultationList",
                            index,
                            "hospitalAmount",
                          ]) ?? 0}
                          /-
                        </h4>
                      </div>
                    </Row>
                  );
                })}

                {!portalSubmission && (
                  <Button
                    type="dashed"
                    // onClick={() => add({ type: "consultationCharges" })}
                    onClick={() =>
                      add({ active: true, type: "consultationCharges" })
                    }
                    style={{
                      color: "white",
                      background: "rgb(0, 76, 143)",
                      border: "1px solid #C4C4C4",
                      boxShadow: "0px 2px 8px 0px #00000040",
                    }}
                    disabled={!isEditable && !!caseClaimSubmissionId}
                  >
                    Add Consultation
                  </Button>
                )}

                <div
                  style={{
                    width: "100%",
                    marginBottom: "0.8rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <h4
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      marginRight: "2rem",
                    }}
                  >
                    Total Consultation Echs Rate: ₹{" "}
                    {totalEchsRateConsultationCharges || 0}/-
                  </h4>

                  <h4 style={{ display: "flex", justifyContent: "end" }}>
                    Total Consultation Amount: ₹{" "}
                    {totalClaimedAmountConsultationCharges || 0}/-
                  </h4>
                </div>
              </>
            )}
          </Form.List>
        </Panel>
      </Collapse> */}
      <Collapse
        defaultActiveKey={["1"]}
        bordered={false}
        style={{
          border: "1px solid lightgray",
          borderRadius: "20px",
          marginBottom: "1rem",
          background: "#F2F6F9",
          padding: "2px 10px",
        }}
      >
        <Panel
          header={<h4 style={{ margin: 0 }}>Implant</h4>}
          key="1"
          style={{ borderRadius: "20px" }}
        >
          {
            isFetchingImplantList ? <div
              style={{
                margin: "auto",
                width: "100%,",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Spin />
            </div> :
          <Form.List name="implantList">
            {(fields, { add, remove }) => (
              <>
                <div
                  style={{
                    maxHeight: "50vh",
                    overflowY: "auto",
                    overflowX: "hidden",
                    padding: "20px",
                    marginBottom: "1rem",
                  }}
                >
                  {fields.map((field, index) => {
                    const itemActive = form.getFieldValue([
                      "implantList",
                      index,
                      "active",
                    ]);
                    if (itemActive === false) return null;

                    return (
                      <Row
                        key={field.key}
                        gutter={[16, 0]}
                        align="top"
                        style={{
                          border: "1px solid black",
                          padding: "10px 20px",
                          borderRadius: "16px",
                          marginBottom: "0.8rem",
                        }}
                      >
                        <Col span={8}>
                          <Form.Item
                            {...field}
                            className="small-label"
                            label="Implant"
                            name={[field.name, "description"]}
                            // rules={[{ required: true, message: "Required" }]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                          >
                            {/* <Input
                          placeholder="Enter Implant Code"
                          disabled={!isEditable && !!caseClaimSubmissionId}
                        /> */}
                            <Select
                              placeholder="Select Implant"
                              disabled={!isEditable && !!caseClaimSubmissionId}
                              allowClear
                              style={{ width: "100%" }}
                              showSearch
                              optionFilterProp="label"
                              options={implantList?.map((implant: any) => ({
                                label: implant.implantName,
                                value: implant.implantName,
                                implantData: implant,
                              }))}
                              onChange={(value, option: any) => {
                                if (option && option.implantData) {
                                  const { implantCode, implantRate } =
                                    option.implantData;

                                  // Auto-fill related fields
                                  form.setFieldsValue({
                                    implantList: {
                                      [index]: {
                                        cghsCode: implantCode,
                                        cghsRate: implantRate.toString(),
                                        daysUnits: "1",
                                        hospitalRate: null,
                                      },
                                    },
                                  });
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={8}>
                          <Form.Item
                            {...field}
                            className="small-label"
                            label="Implant Code"
                            name={[field.name, "cghsCode"]}
                            // rules={[{ required: true, message: "Required" }]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                          >
                            <Input
                              placeholder="Enter Implant Code"
                              disabled={true}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={7}>
                          <Form.Item
                            {...field}
                            className="small-label"
                            label="QUANTITY/NO OF DAYS"
                            name={[field.name, "daysUnits"]}
                            rules={[
                              { required: true, message: "Required" },
                              {
                                pattern: /^\d+$/,
                                message: "Only numeric values are allowed!",
                              },
                            ]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                          >
                            <Input
                              placeholder="Enter QUANTITY/NO OF DAYS"
                              onChange={(e) => {
                                onAmountChange?.();
                                const enteredExpenseUnit =
                                  e.target.value.trim();
                                const hospitalRate = form.getFieldValue([
                                  "implantList",
                                  index,
                                  "hospitalRate",
                                ]);

                                if (hospitalRate && enteredExpenseUnit) {
                                  const hospitalAmount =
                                    parseFloat(hospitalRate) *
                                    parseFloat(enteredExpenseUnit);
                                  form.setFieldsValue({
                                    implantList: {
                                      [index]: {
                                        hospitalAmount:
                                          hospitalAmount?.toString(),
                                      },
                                    },
                                  });
                                }
                              }}
                              disabled={!isEditable && !!caseClaimSubmissionId}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={1}>
                          {fields.length > 0 &&
                            !(!isEditable && !!caseClaimSubmissionId) &&
                            !portalSubmission && (
                              <Button
                                type="text"
                                style={{ color: "red", padding: "0" }}
                                icon={<MinusCircleOutlined />}
                                // onClick={() => remove(field.name)}
                                onClick={() => {
                                  const updatedList =
                                    form.getFieldValue("implantList");
                                  updatedList[index].active = false;
                                  form.setFieldsValue({
                                    implantList: updatedList,
                                  });
                                }}
                              />
                            )}
                        </Col>

                        <Col span={8}>
                          <Form.Item
                            {...field}
                            className="small-label"
                            label="ECHS RATE"
                            name={[field.name, "cghsRate"]}
                            rules={[{ required: false, message: "Required" }]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                          >
                            <Input
                              placeholder="Enter ECHS RATE"
                              disabled={true}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={8}>
                          <Form.Item
                            {...field}
                            className="small-label"
                            label="Hospital Rate"
                            name={[field.name, "hospitalRate"]}
                            rules={[
                              { required: true, message: "Required" },
                              // {
                              //   pattern: /^\d+$/,
                              //   message: "Numeric values are allow!",
                              // },
                              {
                                pattern: /^(\d+(\.\d{1,2})?|\.\d{1,2})$/,
                                message:
                                  "Only numeric values with up to 2 decimal places are allowed!",
                              },
                              {
                                validator: async (_, value) => {
                                  const cghsRate = form.getFieldValue([
                                    "implantList",
                                    index,
                                    "cghsRate",
                                  ]);
                                  if (
                                    value &&
                                    parseFloat(value) > parseFloat(cghsRate)
                                  ) {
                                    return Promise.reject(
                                      new Error(
                                        `Hospital Rate must be lesser than or equal to ${cghsRate}`,
                                      ),
                                    );
                                  }
                                },
                              },
                            ]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                          >
                            <Input
                              placeholder="Enter Hospital Rate"
                              onChange={(e) => {
                                onAmountChange?.();
                                const enteredHospitalRate =
                                  e.target.value.trim();
                                const cghsRate = form.getFieldValue([
                                  "implantList",
                                  index,
                                  "cghsRate",
                                ]);
                                const daysUnits = form.getFieldValue([
                                  "implantList",
                                  index,
                                  "daysUnits",
                                ]);

                                if (
                                  parseFloat(enteredHospitalRate) >
                                  parseFloat(cghsRate)
                                ) {
                                  errorMessage(
                                    `Hospital Rate must be lesser than or equal to ${cghsRate}`,
                                  );
                                } else if (daysUnits && enteredHospitalRate) {
                                  const hospitalAmount =
                                    parseFloat(daysUnits) *
                                    parseFloat(enteredHospitalRate);
                                  form.setFieldsValue({
                                    implantList: {
                                      [index]: {
                                        hospitalAmount:
                                          hospitalAmount?.toString(),
                                      },
                                    },
                                  });
                                }
                              }}
                              disabled={!isEditable && !!caseClaimSubmissionId}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={7}>
                          <Form.Item
                            {...field}
                            className="small-label"
                            label="Remarks"
                            name={[field.name, "remarks"]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                          >
                            <Input
                              placeholder="Enter Remarks"
                              disabled={!isEditable && !!caseClaimSubmissionId}
                            />
                          </Form.Item>
                        </Col>

                        <div style={{ width: "100%" }}>
                          <h4
                            style={{ display: "flex", justifyContent: "end" }}
                          >
                            Hospital Amount: ₹{" "}
                            {form.getFieldValue([
                              "implantList",
                              index,
                              "hospitalAmount",
                            ]) ?? 0}
                            /-
                          </h4>
                        </div>
                      </Row>
                    );
                  })}
                </div>

                {!portalSubmission && (
                  <Button
                    type="dashed"
                    // onClick={() => add({ type: "implantCharges" })}
                    onClick={() =>
                      add({ active: true, type: "implantCharges" })
                    }
                    style={{
                      color: "white",
                      background: "rgb(0, 76, 143)",
                      border: "1px solid #C4C4C4",
                      boxShadow: "0px 2px 8px 0px #00000040",
                    }}
                    disabled={!isEditable && !!caseClaimSubmissionId}
                  >
                    Add Implants
                  </Button>
                )}

                <div
                  style={{
                    width: "100%",
                    marginBottom: "0.8rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <h4
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      marginRight: "2rem",
                    }}
                  >
                    Total Implant Echs Rate: ₹ {totalEchsImplantCharges || 0}/-
                  </h4>

                  <h4 style={{ display: "flex", justifyContent: "end" }}>
                    Total Implant Amount: ₹{" "}
                    {totalClaimedAmountImplantCharges || 0}/-
                  </h4>
                </div>
              </>
            )}
          </Form.List>
}
        </Panel>
      </Collapse>
      <Collapse
        defaultActiveKey={["1"]}
        bordered={false}
        style={{
          border: "1px solid lightgray",
          borderRadius: "20px",
          marginBottom: "1rem",
          background: "#F2F6F9",
          padding: "2px 10px",
        }}
      >
        <Panel
          header={<h4 style={{ margin: 0 }}>Unlisted Procedure</h4>}
          key="1"
          style={{ borderRadius: "20px" }}
        >
          <Form.List name="unlistedProcedureList">
            {(fields, { add, remove }) => (
              <>
                <div
                  style={{
                    maxHeight: "50vh",
                    overflowY: "auto",
                    overflowX: "hidden",
                    padding: "20px",
                    marginBottom: "1rem",
                  }}
                >
                  {fields.map((field, index) => {
                    const itemActive = form.getFieldValue([
                      "unlistedProcedureList",
                      index,
                      "active",
                    ]);
                    if (itemActive === false) return null;

                    return (
                      <Row
                        key={field.key}
                        gutter={[16, 0]}
                        align="top"
                        style={{
                          border: "1px solid black",
                          padding: "10px 20px",
                          borderRadius: "16px",
                          marginBottom: "0.8rem",
                        }}
                      >
                        <Col span={8}>
                          <Form.Item
                            {...field}
                            className="small-label"
                            label="Unlisted Procedure"
                            name={[field.name, "cghsCode"]}
                            rules={[{ required: true, message: "Required" }]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                          >
                            <Input
                              placeholder="Enter Unlisted Procedure"
                              disabled={!isEditable && !!caseClaimSubmissionId}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={8}>
                          <Form.Item
                            {...field}
                            className="small-label"
                            label="Total Amount"
                            name={[field.name, "totalAmount"]}
                            rules={[
                              // { required: true, message: "Required" },
                              {
                                pattern: /^\d+$/,
                                message: "Numeric values are allow!",
                              },
                            ]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                          >
                            <Input
                              placeholder="Enter Total Amount"
                              disabled={!isEditable && !!caseClaimSubmissionId}
                              onChange={() => onAmountChange?.()}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={7}>
                          <Form.Item
                            {...field}
                            className="small-label"
                            label="Remarks"
                            name={[field.name, "remarks"]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                          >
                            <Input
                              placeholder="Enter Remarks"
                              disabled={!isEditable && !!caseClaimSubmissionId}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={1}>
                          {fields.length > 0 &&
                            !(!isEditable && !!caseClaimSubmissionId) &&
                            !portalSubmission && (
                              <Button
                                type="text"
                                style={{ color: "red", padding: "0" }}
                                icon={<MinusCircleOutlined />}
                                // onClick={() => remove(field.name)}
                                onClick={() => {
                                  const updatedList = form.getFieldValue(
                                    "unlistedProcedureList",
                                  );
                                  updatedList[index].active = false;
                                  form.setFieldsValue({
                                    unlistedProcedureList: updatedList,
                                  });
                                }}
                              />
                            )}
                        </Col>

                        <div style={{ width: "100%" }}>
                          <h4
                            style={{ display: "flex", justifyContent: "end" }}
                          >
                            Hospital Amount: ₹{" "}
                            {form.getFieldValue([
                              "unlistedProcedureList",
                              index,
                              "totalAmount",
                            ]) ?? 0}
                            /-
                          </h4>
                        </div>
                      </Row>
                    );
                  })}
                </div>

                {!portalSubmission && (
                  <Button
                    type="dashed"
                    onClick={() =>
                      add({ active: true, type: "UnlistedProcedure" })
                    }
                    style={{
                      color: "white",
                      background: "rgb(0, 76, 143)",
                      border: "1px solid #C4C4C4",
                      boxShadow: "0px 2px 8px 0px #00000040",
                    }}
                    disabled={!isEditable && !!caseClaimSubmissionId}
                  >
                    Add Unlisted Procedure
                  </Button>
                )}

                <div
                  style={{
                    width: "100%",
                    marginBottom: "0.8rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <h4 style={{ display: "flex", justifyContent: "end" }}>
                    Total Unlisted Procedure Amount: ₹{" "}
                    {totalClaimedAmountUnlistedProcedure || 0}/-
                  </h4>
                </div>
              </>
            )}
          </Form.List>
        </Panel>
      </Collapse>

      <Collapse
        defaultActiveKey={["1"]}
        bordered={false}
        style={{
          border: "1px solid lightgray",
          borderRadius: "20px",
          marginBottom: "1rem",
          background: "#F2F6F9",
          padding: "2px 10px",
        }}
      >
        <Panel
          header={<h4 style={{ margin: 0 }}>Other Expenses</h4>}
          key="1"
          style={{ borderRadius: "20px" }}
        >
          <Row
            gutter={[16, 0]}
            align="top"
            style={{
              border: "1px solid black",
              padding: "10px 20px",
              borderRadius: "16px",
              marginBottom: "0.8rem",
            }}
          >
            <Row gutter={[16, 0]} style={{ width: "100%" }}>
              <Col span={12}>
                <Form.Item
                  label="Pharmacy & Consumable Charges"
                  name={"pharmacyAndConsumableCharges"}
                  className="small-label"
                  // rules={[{ required: true, message: "Required" }]}
                  rules={[
                    // { required: true, message: "Required" },
                    {
                      pattern: /^\d+$/,
                      message: "Numeric values are allow!",
                    },
                  ]}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input
                    placeholder="Enter Pharmacy & Consumable Charges"
                    disabled={!isEditable && !!caseClaimSubmissionId}
                    onChange={() => onAmountChange?.()}
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label="Remarks"
                  name={"procedureAndConsumableChargesRemarks"}
                  className="small-label"
                  // rules={[{ required: true, message: "Required" }]}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input
                    placeholder="Enter Pharmacy & Consumable Charges Remarks"
                    disabled={!isEditable && !!caseClaimSubmissionId}
                    onChange={() => onAmountChange?.()}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 0]} style={{ width: "100%" }}>
              <Col span={12}>
                <Form.Item
                  label="Other Charges"
                  name={"otherCharges"}
                  className="small-label"
                  // rules={[{ required: true, message: "Required" }]}
                  rules={[
                    // { required: true, message: "Required" },
                    {
                      pattern: /^\d+$/,
                      message: "Numeric values are allow!",
                    },
                  ]}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input
                    placeholder="Enter Other Charges"
                    disabled={!isEditable && !!caseClaimSubmissionId}
                    onChange={() => onAmountChange?.()}
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label="Remarks"
                  name={"otherChargesRemarks"}
                  className="small-label"
                  // rules={[{ required: true, message: "Required" }]}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input
                    placeholder="Enter Other Charges Remarks"
                    disabled={!isEditable && !!caseClaimSubmissionId}
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* <Row gutter={[16, 0]} style={{ width: "100%" }}>
              <Col span={12}>
                <Form.Item
                  label="amount Received From Patient"
                  name={"amountReceivedFromPatient"}
                  className="small-label"
                  // rules={[{ required: true, message: "Required" }]}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input
                    placeholder="Enter amount Received From Patient"
                    disabled={!isEditable && !!caseClaimSubmissionId}
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label="Discount (if any)"
                  name={"discount"}
                  className="small-label"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input
                    placeholder="Enter Discount"
                    disabled={!isEditable && !!caseClaimSubmissionId}
                  />
                </Form.Item>
              </Col>
            </Row> */}
          </Row>
        </Panel>
      </Collapse>
      <Collapse
        defaultActiveKey={["1"]}
        bordered={false}
        style={{
          border: "1px solid lightgray",
          borderRadius: "20px",
          marginBottom: "1rem",
          background: "#F2F6F9",
          padding: "2px 10px",
        }}
      >
        <Panel
          header={<h4 style={{ margin: 0 }}>Deductions</h4>}
          key="1"
          style={{ borderRadius: "20px" }}
        >
          <Row
            gutter={[16, 0]}
            align="top"
            style={{
              border: "1px solid black",
              padding: "10px 20px",
              borderRadius: "16px",
              marginBottom: "0.8rem",
            }}
          >
            <Row gutter={[16, 0]} style={{ width: "100%" }}>
              <Col span={12}>
                <Form.Item
                  label="amount Received From Patient"
                  name={"amountReceivedFromPatient"}
                  className="small-label"
                  // rules={[{ required: true, message: "Required" }]}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    // { required: true, message: "Required" },
                    {
                      pattern: /^(\d+(\.\d{1,2})?|\.\d{1,2})$/,
                      message: "Only numeric values with upto 2 dec. places!",
                    },
                    {
                      validator: (_, value) =>
                        value && parseInt(value, 10) < 1
                          ? Promise.reject("Please Enter Valid Amount!")
                          : Promise.resolve(),
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter amount Received From Patient"
                    disabled={!isEditable && !!caseClaimSubmissionId}
                    onChange={() => onAmountChange?.()}
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label="Discount (if any)"
                  name={"discount"}
                  className="small-label"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    // { required: true, message: "Required" },
                    {
                      pattern: /^(\d+(\.\d{1,2})?|\.\d{1,2})$/,
                      message: "Only numeric values with upto 2 dec. places!",
                    },
                    {
                      validator: (_, value) =>
                        value && parseInt(value, 10) < 1
                          ? Promise.reject("Please Enter Valid Amount!")
                          : Promise.resolve(),
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Discount"
                    disabled={!isEditable && !!caseClaimSubmissionId}
                    onChange={() => onAmountChange?.()}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Row>
        </Panel>
      </Collapse>
    </>
  );
};

export default EchsExtraForm;
